import { useEffect, useRef, useState } from "react";

export const useFlash = (intervalMs: number, condition: boolean) => {
    const [flashOn, setFlashOn] = useState(false);
    const isFlashingRef = useRef(false);
    const intervalHandleRef = useRef<ReturnType<typeof setInterval>>(0);
    const intervalMsRef = useRef(intervalMs);
    intervalMsRef.current = intervalMs;

    useEffect(() => {
        if (condition && !isFlashingRef.current) {
            clearInterval(intervalHandleRef.current);
            intervalHandleRef.current = setInterval(() => {
                setFlashOn((prev) => !prev);
            }, intervalMsRef.current);
        }
        else if (!condition && isFlashingRef.current) {
            clearInterval(intervalHandleRef.current);
            intervalHandleRef.current = 0;
            setFlashOn(false);
        }
    }, [condition]);

    return flashOn;
};